export default {
  momentLocale: 'tr',
  Timeline: {
    expand: 'Genişlet',
    fold: 'Gizle',
  },
  Balloon: {
    close: 'Kapat',
    confirm: 'Tamam',
    cancel: 'İptal',
  },
  Card: {
    expand: 'Genişlet',
    fold: 'Gizle',
  },
  Calendar: {
    today: 'Bugün',
    now: 'Şu Anda',
    ok: 'Tamam',
    clear: 'Temizle',
    month: 'Ay',
    year: 'yıl',
    prevYear: 'Geçen yıl',
    nextYear: 'gelecek yıl',
    prevMonth: 'Geçen Ay',
    nextMonth: 'Gelecek ay',
    prevDecade: 'Önceki Oniki Yıl',
    nextDecade: 'On iki yıl sonra',
    yearSelectAriaLabel: 'Yıl Seçin',
    monthSelectAriaLabel: 'Ay Seçin',
    format: {
      months: '1 ay_2 ay_3 ay_4 ay_5 ay_6 ay_7 ay_8 ay_9 ay_10 ay_11 ay_12 ay'.split('_'),
      shortMonths: '1 ay_2 ay_3 ay_4 ay_5 ay_6 ay_7 ay_8 ay_9 ay_10 ay_11 ay_12 ay'.split('_'),
      weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
      shortWeekdays: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
      veryShortWeekdays: '日_一_二_三_四_五_六'.split('_'),
      yearLabel: 'YYYY',
    },
  },
  DatePicker: {
    placeholder: 'Lütfen bir tarih seçin',
    datetimePlaceholder: 'Lütfen tarihi ve saati seçin',
    monthPlaceholder: 'Lütfen bir ay seçin',
    yearPlaceholder: 'Lütfen yıl seçin',
    now: 'Şimdi',
    selectTime: 'Zaman seçin',
    selectDate: 'Tarih seç',
    ok: 'Tamam',
    clear: 'Temizle',
    startPlaceholder: 'Başlangıç tarihi',
    endPlaceholder: 'Bitiş Tarihi',
    hour: 'Saat',
    minute: 'dakika',
    second: 'saniye',
  },
  Dialog: {
    close: 'Kapat',
    ok: 'Tamam',
    cancel: 'İptal',
  },
  Message: {
    closeAriaLabel: 'Kapat',
  },
  Pagination: {
    goTo: 'Git',
    page: 'Sayfa',
    total: '{current}. sayfa, toplam {total} sayfa',
    labelPrev: 'Önceki sayfa, şu anki {current} sayfa',
    labelNext: 'Sonraki sayfa, şu anki {current}. sayfa',
    inputAriaLabel: 'Lütfen hangi sayfaya gitmek istediğinizi yazın',
    selectAriaLabel: 'Sayfa başına kaç adet göstermek istediğinizi seçin',
    pageSize: 'Madde/Sayfa',
  },
  Input: {
    clear: 'Temizle',
  },
  Select: {
    selectPlaceholder: 'Lütfen seçin',
    autoCompletePlaceholder: 'Lütfen girin',
    notFoundContent: 'Seçenek yok',
    maxTagPlaceholder: '{selected}/{total} öğe seçildi',
  },
  Table: {
    empty: 'Veri yok',
    ok: 'Tamam',
    reset: 'Sıfırla',
    asc: 'Artan Sıra',
    desc: 'Azalan',
    expanded: 'Açıldı',
    folded: 'Katıldı',
    filter: 'Filtrele',
    selectAll: 'Tümünü Seç',
  },
  TimePicker: {
    placeholder: 'Lütfen zaman seçin',
    startPlaceholder: 'Başlangıç Zamanı',
    endPlaceholder: 'Bitiş saati',
    clear: 'Temizle',
    hour: 'saat',
    minute: 'dk',
    second: 'saniye',
  },
  Transfer: {
    items: 'öğe',
    item: 'öğe',
    moveAll: 'Tümünü Taşı',
    searchPlaceholder: 'Lütfen girin',
    moveToLeft: 'Seçimi geri al',
    moveToRight: 'Seçilen öğeleri gönder',
  },
  Upload: {
    card: {
      cancel: 'İptal',
      addPhoto: 'Resim yükle',
      download: 'İndir',
      delete: 'Sil',
    },
    drag: {
      text: 'Dosyayı tıklayarak veya sürükleyerek çizgili kutuya yükleyin',
      hint: 'docx, xls, PDF, rar, zip, PNG, JPG gibi dosya türlerini destekler',
    },
    upload: {
      delete: 'Sil',
    },
  },
  Search: {
    buttonText: 'Ara',
  },
  Tag: {
    delete: 'Sil',
  },
  Rating: {
    description: 'Değerlendirme seçenekleri',
  },
};
